import React from 'react';
import { Loader2 } from 'lucide-react';

const LoadingState = ({ label = 'Loading...', fullPage = false }) => (
  <div
    role="status"
    aria-live="polite"
    className={`flex flex-col items-center justify-center gap-3 text-ink-secondary ${fullPage ? 'min-h-[60vh]' : 'py-16'}`}
  >
    <Loader2 className="animate-spin text-accent-500" size={32} aria-hidden="true" />
    <span className="text-sm font-medium">{label}</span>
  </div>
);

export default LoadingState;
